/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-lines-per-function */
import { useHookstate, type State } from '@hookstate/core'
import { LoadingButton } from '@mui/lab'
import {
  Button,
  Collapse,
  Grid,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import React from 'react'
import FilterAutocompleteFetch from '~/components/FilterAutocompleteFetch'
import FilterSelectPeriod from '~/components/FilterAutocompletePeriod'
import { useLang } from '~/hooks/useLang'

interface AuditKeywordsFiltersProps {
  readonly hidden?: boolean
  readonly labelButton?: State<string>
  readonly loadingButton: State<boolean>
  readonly resetValues?: State<boolean>
  readonly focusChange?: State<boolean>
  readonly userId?: State<number | null>
  readonly initialPeriod: State<string>
  readonly onPeriodChange: (value: string) => void
  readonly onStartDateChange: (value: string | null) => void
  readonly onFinishDateChange: (value: string | null) => void
  readonly clearFilters: () => void
  readonly searchButton?: () => void
  readonly searchType: State<string | null>
}

export default function AuditKeywordsFilters({
  hidden,
  labelButton,
  loadingButton,
  userId,
  resetValues,
  focusChange,
  initialPeriod,
  onStartDateChange,
  onFinishDateChange,
  onPeriodChange,
  clearFilters,
  searchButton,
  searchType,
}: AuditKeywordsFiltersProps) {
  const { translate } = useLang()
  const selectTypeSearch = useHookstate<string | null>('1')

const searchTypeOptions = [
  { value: 'occurrence_list', label: translate('Entry - Occurrence List') },
  { value: 'dispatch_list', label: translate('Dispatch - Dispatch List') },
  { value: 'video_surveillance', label: translate('Video Surveillance') },
  { value: 'statistics_dispatch', label: translate('Dispatch Statistics') },
  { value: 'search_multiple_coments_report', label: translate('Search Report by Multiple Comments') },
  { value: 'word_cloud', label: translate('Word Cloud') },
  { value: 'connection_logs_report', label: translate('Connection Logs Reports') },
]
  return (
    <Collapse in={hidden}>
      <Grid container xs={12} sx={{ width: '100%', display: 'flex', alignItems: 'center' }}>
        <Grid container direction={'column'} display={'flex'} gap={1}>
          <Grid container direction={'row'} flexWrap={'wrap'}>
            <Grid item xs={2} sx={{ pl: 1, pt: 1 }}>
              <FormControl fullWidth size="small">
                <InputLabel id="local-consultado-label">{translate('Consulted origin')}</InputLabel>
                <Select
                  labelId="local-consultado-label"
                  id="local-consultado"
                  value={searchType.get() || ''}
                  label={translate('Consulted origin')}
                  onChange={(e) => searchType.set(e.target.value)}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 300,
                        width: 200,
                      },
                    },
                  }}
                  sx={{ 
                    '& .MuiMenuItem-root': { 
                      whiteSpace: 'normal',
                      wordWrap: 'break-word',
                    } 
                  }}
                  endAdornment={
                    searchType.get() ? (
                      <IconButton
                        size="small"
                        onClick={() => searchType.set(null)}
                        sx={{ marginRight: 2 }}
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    ) : null
                  }
                >
                  {searchTypeOptions.map((option) => (
                    <MenuItem 
                      key={option.value} 
                      value={option.value}
                      sx={{ 
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                      }}
                    >
                      {option.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={2} sx={{ pl: 1, pt: 1 }}>
              <FilterAutocompleteFetch
                label={translate('User')}
                urlFetch={'/user/get'}
                dataRequest={'user'}
                size={'small'}
                disabled={false}
                onFetchChange={(user: number | null) => userId?.set(user)}
                resetValues={resetValues?.get()}
                focusChange={focusChange}
                valueId={userId?.get() ? Number(userId?.get()) : undefined}
              />
            </Grid>

            <FilterSelectPeriod
              onStartDateChange={(value) =>
                onStartDateChange(value?.toJSON() ?? null)
              }
              onFinishDateChange={(value) =>
                onFinishDateChange(value?.toJSON() ?? null)
              }
              onPeriodChange={onPeriodChange}
              period={initialPeriod.get()}
              xsDateBetween={2}
              xsPeriod={2}
              hidePeriod={false}
              marginDateBetween={0}
              disableFuture={false}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid
        container
        direction={'row'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
          pt: 4,
          gap: 2,
        }}
      >
        <Button
          variant="outlined"
          onClick={() => {
            clearFilters()
            selectTypeSearch?.set('1')
            searchType.set(null)
          }}
        >
          {translate('Clear Filters')}
        </Button>
        <LoadingButton
          loading={loadingButton.get()}
          variant="contained"
          onClick={searchButton}
        >
          {labelButton?.get()}
        </LoadingButton>
      </Grid>
    </Collapse>
  )
}
